import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';

const alerts = [
  "🚨 Alerte Bénin : Hausse des fausses offres d'emploi sur WhatsApp.",
  "⚠️ Prudence : Nouveaux SMS frauduleux ciblant les utilisateurs MoMo.",
  "🛡️ Conseil : Ne partagez jamais votre code OTP par téléphone.",
];

export default function AnimatedAlerts() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % alerts.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="mx-4 mt-6 bg-red-50 border border-red-100 rounded-2xl p-3 flex items-center gap-3 overflow-hidden shadow-sm relative">
      <div className="w-8 h-8 rounded-full bg-red-100 text-red-600 flex items-center justify-center flex-shrink-0 z-10">
        <ShieldAlert className="w-4 h-4" />
      </div>
      
      <div className="flex-1 relative h-6 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ y: 20, opacity: 0, rotateX: -90 }}
            animate={{ y: 0, opacity: 1, rotateX: 0 }}
            exit={{ y: -20, opacity: 0, rotateX: 90 }}
            transition={{ duration: 0.4, type: "spring", stiffness: 200, damping: 20 }}
            className="absolute inset-0 flex items-center text-xs font-semibold text-red-800"
            style={{ transformOrigin: "center center -10px" }}
          >
            {alerts[index]}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
